'use client';
import { Icon } from '@fm-nx/svg';
import React, { useEffect, useRef } from 'react';
import { useSearchBox } from 'react-instantsearch';

const SearchBox = () => {
    const { query, refine, clear } = useSearchBox();
    const inputReference = useRef(null);

    useEffect(() => {
        if (inputReference.current) {
            (inputReference.current as HTMLInputElement).focus();
        }
    }, []);

    const placeholder = 'What are you looking for? e.g. Technologies...';

    return (
        <div className="relative">
            <input
                className="w-full h-16 p-8 pr-16 text-xl text-white bg-gray-900 border border-white placeholder-gray-500 font-headline"
                type="text"
                ref={inputReference}
                placeholder={placeholder}
                value={query}
                onChange={(event) => {
                    refine(event.currentTarget.value);
                }}
                onKeyDown={(e) => {
                    const stopKeys = [
                        'Enter',
                        ' ', // Space Key
                    ];
                    if (stopKeys.includes(e.key)) {
                        e.stopPropagation();
                    }
                }}
            />
            <span className="absolute right-8 top-[17px] motion-safe:animate-waving-hand animation-delay-1000">
                <Icon name="zoom" color="white" size={'lg'} />
            </span>
            {query && (
                <button
                    type="button"
                    aria-label="Clear search input"
                    onClick={() => clear()}
                    className="group bg-transparent absolute -bottom-[3px] right-1 p-3"
                >
                    <Icon name="close" color="white" />
                </button>
            )}
        </div>
    );
};

export default SearchBox;
